var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1593",
    "data-name": "Group 1593",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.84,
    height: 131.177,
    viewBox: "0 0 120.84 131.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.753,
    y1: -0.256,
    x2: 0.446,
    y2: 0.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dc3c54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#b22c58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f1e5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.481,
    y1: -0.07,
    x2: 0.53,
    y2: 0.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.588,
    y1: -0.113,
    x2: 0.454,
    y2: 0.976,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.452,
    y1: 0.075,
    x2: 0.535,
    y2: 1.053,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.294,
    y1: 0.18,
    x2: 0.692,
    y2: 1.165,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.31,
    y1: 0.328,
    x2: 0.66,
    y2: 1.096,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.262,
    y1: 0.012,
    x2: 0.705,
    y2: 0.917,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M223.952,80.468l.078-.068c-.488.029-.976.083-1.429.151-.361.049-.722.112-1.078.185a19.893,19.893,0,0,0-3.22.922,20.105,20.105,0,0,0-7.318,4.8c-.054.415-.1.834-.137,1.254a39.857,39.857,0,0,0,.566,11.348c1.356,6.981,4.274,14,13.84,20.09h.078l.488-.151a28.2,28.2,0,0,1-1.9-38.428A.188.188,0,0,1,223.952,80.468Z",
    transform: "translate(-107.893 -41.176)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M186.911,48.96c-.083.629-.156,1.264-.215,1.9a51.947,51.947,0,0,0,5.581,28.784c.141.278.293.546.439.82q.576,1.073,1.2,2.112a51.825,51.825,0,0,0,15.611,16.46c.141.1.273.2.415.288l.161.1.054-.054.171-.166c.1-.083.2-.156.3-.229a6.045,6.045,0,0,1,1.434-.615c-9.972-6.166-12.977-13.3-14.358-20.407a40.322,40.322,0,0,1-.7-9.269c0-.517.049-1.034.093-1.547a40,40,0,0,1,14.543-27.715c-.229-.024-.488-.039-.693-.054-.463-.034-.922-.063-1.385-.073a29.7,29.7,0,0,0-6.391.537A29.379,29.379,0,0,0,186.911,48.96Z",
    transform: "translate(-95.494 -20.118)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M163.659,64.689q1.312,1.951,2.786,3.791l.576.717a61.26,61.26,0,0,0,19.358,15.728l.62.317q2.493,1.249,5.074,2.269a5.909,5.909,0,0,1,.278-.556l-.093-.059c-.249-.156-.488-.312-.746-.488-.42-.273-.834-.561-1.244-.844h-.029a51.893,51.893,0,0,1-12.474-12.318c-.6-.839-1.176-1.708-1.737-2.591-.8-1.278-1.561-2.6-2.269-3.961a51.948,51.948,0,0,1-5.7-26.964c.049-.737.1-1.464.176-2.205a52.444,52.444,0,0,1,8.913-24.285q-1.332.254-2.654.6a38.716,38.716,0,0,0-21.383,14.636,61.177,61.177,0,0,0,10.547,36.209Z",
    transform: "translate(-78.398 -6.781)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M137.086,68.954c9.9,7.6,20.3,12.313,31.55,14.2l.824.132.059-.293c.024-.093.044-.185.068-.278A61.115,61.115,0,0,1,144.965,65.8q-.8-.893-1.556-1.829A61.626,61.626,0,0,1,134.2,1.44q-1.464.615-2.927,1.342A45.683,45.683,0,0,0,110,25.389a72.69,72.69,0,0,0,16.124,33.174,73.408,73.408,0,0,0,10.962,10.391Z",
    transform: "translate(-56.333 -0.737)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M93.247,72.993a81.425,81.425,0,0,0,9.518,5.269A79.311,79.311,0,0,0,142.5,85.58c.761-.059,1.522-.132,2.283-.21,0-.22-.024-.439-.039-.659v-.824q-2.673-.4-5.327-.976a72.52,72.52,0,0,1-28.447-13.328,73.454,73.454,0,0,1-6.488-5.61A72.6,72.6,0,0,1,84.241,27.735,73.3,73.3,0,0,1,83.392,0c-1.02.742-2.02,1.522-2.991,2.342A54.011,54.011,0,0,0,62,34.174,79.184,79.184,0,0,0,93.247,72.993Z",
    transform: "translate(-31.75 0)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M68.954,104.867a84.618,84.618,0,0,0,17.67,1.854,83.424,83.424,0,0,0,32.15-6.4q-3.186.234-6.391.21a79.316,79.316,0,0,1-33.174-7.537l-.624-.3a79.364,79.364,0,0,1-39.35-41.819,80.169,80.169,0,0,1-5.752-25.549v-.1c-.917,1.034-1.8,2.1-2.644,3.2A59.031,59.031,0,0,0,19.212,72.688a83.311,83.311,0,0,0,49.742,32.179Z",
    transform: "translate(-9.535 -12.916)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M116.658,151c-1.244,0-2.059-.815-2.439-2.415-.385-1.7-.634-3.454-.825-4.947a3.6,3.6,0,0,0-.054-.454l-.059-.522-.073-.693-.044-.439A83.37,83.37,0,0,1,76.3,150.066q-3.966,0-7.835-.361a83.672,83.672,0,0,1-54.65-27.647q-1.8-2.034-3.464-4.186a.336.336,0,0,1,0,.063A83.544,83.544,0,0,1,2.495,105.92c-.415,1.39-.732,2.849-1.044,4.274a61.909,61.909,0,0,0,116.007,40.648,2.394,2.394,0,0,1-.79.137Z",
    transform: "translate(0.006 -54.246)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M184.638,178.067a20.344,20.344,0,1,1,20.339-20.342A20.345,20.345,0,0,1,184.638,178.067Z",
    transform: "translate(-84.137 -70.358)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 18.617,
    cy: 18.617,
    r: 18.617,
    transform: "translate(81.894 68.749)",
    fill: "#901f5d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M210.185,165.449l-13.236-10.094a1.649,1.649,0,0,0-2.649,1.307v20.192a1.649,1.649,0,0,0,2.649,1.307l13.236-10.094a1.649,1.649,0,0,0,0-2.62Z",
    transform: "translate(-99.507 -79.391)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.2c1c9df4.svg";
export { ForwardRef as ReactComponent };